// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g-root {
  --dl-navigation-breadcrumbs-height: 28px;
  --dl-revision-panel-top-offset: 40px;
  --dl-color-border: var(--g-color-line-generic);
  --dl-color-border-solid: var(--g-color-line-generic-solid);
  --dl-color-progress-bar: var(--g-color-text-info);
  --dl-color-progress-bar-failed: var(--g-color-base-danger-heavy);
  --dl-color-field-dimenson: var(--g-color-base-positive-light);
  --dl-color-field-dimenson-hover: var(--g-color-base-positive-light-hover);
  --dl-color-field-measure: var(--g-color-base-info-light);
  --dl-color-field-measure-hover: var(--g-color-base-info-light-hover);
  --dl-color-field-dimenson-solid: var(--g-color-text-positive);
  --dl-color-field-measure-solid: var(--g-color-text-info);
  --dl-color-entity-chart-wizard: #5282ff;
  --dl-color-entity-chart-ql: #9f6fee;
  --dl-color-entity-chart-editor: #e18c1e;
  --dl-color-entity-connection: #9a32a6;
  --dl-color-entity-dataset: #0abe05;
  --dl-color-entity-dashboard: #ff8c3c;
  --dl-color-widget-background: var(--g-color-base-float);
  --dl-color-text-workbook-icon: var(--g-color-text-dark-primary);
  --dl-viz-icon-main-color: #3d97f2;
  --dl-viz-icon-secondary-color: #ff6a59;
}
.g-root_theme_light {
  --g-color-private-cool-grey-20-solid: rgb(245, 246, 247);
  --ds-color-relation-line: #d9d9d9;
  --ds-color-avatar: #ededed;
  --w-local-item-border: rgba(0, 0, 0, 0.5);
  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);
  --w-disabled-item-background: rgba(0, 0, 0, 0.07);
  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);
  --dl-color-base-workbook-icon: #d1dfff;
  --dl-filter-ymap-background: none;
  --dl-filter-ymap-heatmap: none;
  --dl-color-ymap-background: #fafafa;
  --dl-filter-zoom-control: none;
  --dl-color-dashboard-background: var(--g-color-private-cool-grey-20-solid);
  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-100-solid);
}
.g-root_theme_light-hc {
  --ds-color-relation-line: #d9d9d9;
  --ds-color-avatar: #ededed;
  --w-local-item-border: rgba(0, 0, 0, 0.5);
  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);
  --w-disabled-item-background: rgba(0, 0, 0, 0.07);
  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);
  --dl-color-base-workbook-icon: #a8c3ff;
  --dl-filter-ymap-background: none;
  --dl-filter-ymap-heatmap: none;
  --dl-color-ymap-background: #fafafa;
  --dl-filter-zoom-control: none;
  --dl-color-dashboard-background: var(--g-color-private-cool-grey-50-solid);
  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-150-solid);
}
.g-root_theme_dark {
  --g-color-private-white-20-solid: rgb(49, 48, 55);
  --ds-color-relation-line: #4c4b51;
  --ds-color-avatar: #3b3a41;
  --w-local-item-border: rgba(255, 255, 255, 0.5);
  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);
  --w-disabled-item-background: rgba(255, 255, 255, 0.07);
  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);
  --dl-color-base-workbook-icon: #c2d0f0;
  --dl-filter-ymap-background: invert(0.9) saturate(0.4) hue-rotate(-30deg);
  --dl-filter-ymap-heatmap: invert(0.9) saturate(0.4) hue-rotate(-30deg);
  --dl-color-ymap-background: transparent;
  --dl-filter-zoom-control: invert(1);
  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);
  --dl-color-fixed-header-background: var(--g-color-base-background);
}
.g-root_theme_dark-hc {
  --g-color-private-white-20-solid: rgb(38, 39, 42);
  --ds-color-relation-line: #4c4b51;
  --ds-color-avatar: #3b3a41;
  --w-local-item-border: rgba(255, 255, 255, 0.5);
  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);
  --w-disabled-item-background: rgba(255, 255, 255, 0.07);
  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);
  --dl-color-base-workbook-icon: #c0d3fd;
  --dl-filter-ymap-background: invert(0.95) saturate(0.4) hue-rotate(-30deg);
  --dl-filter-ymap-heatmap: invert(0.95) saturate(0.4) hue-rotate(-30deg);
  --dl-color-ymap-background: transparent;
  --dl-filter-zoom-control: invert(1);
  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);
  --dl-color-fixed-header-background: var(--g-color-base-background);
}

@keyframes pulseAnimation {
  0% {
    opacity: 0.65;
  }
  50% {
    opacity: 0.35;
  }
  100% {
    opacity: 0.65;
  }
}
.dialog-parameter {
  width: 560px;
}
.dialog-parameter__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  row-gap: 20px;
  overflow: visible;
}
.dialog-parameter__line {
  display: flex;
  align-items: center;
  width: 100%;
  column-gap: 16px;
  min-height: 28px;
}
.dialog-parameter__line-title {
  flex: 0 0 180px;
  line-height: 18px;
}
.dialog-parameter__line-title_vertical-align-start {
  margin-bottom: auto;
  transform: translateY(5px);
}
.dialog-parameter__line-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.dialog-parameter__switch-template {
  display: flex;
  align-items: center;
  height: 28px;
  margin-right: auto;
}
.dialog-parameter__textarea-regex {
  margin-top: 8px;
}
.dialog-parameter__validation-hint {
  margin-top: 4px;
  color: var(--g-color-text-hint);
}
.dialog-parameter__template-warning {
  margin-top: 8px;
  color: var(--g-color-text-warning-heavy);
}
.dialog-parameter__title-tooltip {
  margin-left: var(--g-spacing-1);
  vertical-align: middle;
}
.dialog-parameter__title-tooltip .yfm {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-1-font-size);
  line-height: var(--g-text-body-1-line-height);
}
.dialog-parameter__loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.dialog-parameter__dialog-popup {
  max-height: 40vh;
  max-width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/variables.scss","webpack://./src/ui/components/DialogParameter/DialogParameter.scss","webpack://./src/ui/styles/mixins.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AA6BA;EACI,wCAAA;EACA,oCAAA;EAEA,8CAAA;EACA,0DAAA;EACA,iDAAA;EACA,gEAAA;EAEA,6DAAA;EACA,yEAAA;EACA,wDAAA;EACA,oEAAA;EACA,6DAAA;EACA,wDAAA;EAEA,uCAAA;EACA,mCAAA;EACA,uCAAA;EACA,qCAAA;EACA,kCAAA;EACA,oCAAA;EAEA,uDAAA;EAEA,+DAAA;EAEA,iCAAA;EACA,sCAAA;AClCJ;ADoCI;EAEI,wDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,iDAAA;EACA,0CAAA;EACA,sCAAA;EACA,iCAAA;EACA,8BAAA;EACA,mCAAA;EACA,8BAAA;EACA,0EAAA;EACA,8EAAA;ACpCR;ADuCI;EACI,iCAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,iDAAA;EACA,0CAAA;EACA,sCAAA;EACA,iCAAA;EACA,8BAAA;EACA,mCAAA;EACA,8BAAA;EACA,0EAAA;EACA,8EAAA;ACrCR;ADwCI;EACI,iDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,+CAAA;EACA,wDAAA;EACA,uDAAA;EACA,gDAAA;EACA,sCAAA;EACA,yEAAA;EACA,sEAAA;EACA,uCAAA;EACA,mCAAA;EACA,sEAAA;EACA,kEAAA;ACvCR;AD0CI;EACI,iDAAA;EAEA,iCAAA;EACA,0BAAA;EACA,+CAAA;EACA,wDAAA;EACA,uDAAA;EACA,gDAAA;EACA,sCAAA;EACA,0EAAA;EACA,uEAAA;EACA,uCAAA;EACA,mCAAA;EACA,sEAAA;EACA,kEAAA;ACzCR;;ACuEA;EACI;IACI,aAAA;EDpEN;ECsEE;IACI,aAAA;EDpEN;ECsEE;IACI,aAAA;EDpEN;AACF;AAhGA;EACI,YAAA;AAkGJ;AAhGI;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AAkGR;AA/FI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAiGR;AA9FI;EACI,eAAA;EACA,iBAAA;AAgGR;AA9FQ;EACI,mBAAA;EACA,0BAAA;AAgGZ;AA5FI;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AA8FR;AA3FI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA6FR;AA1FI;EACI,eAAA;AA4FR;AAzFI;EACI,eAAA;EACA,+BAAA;AA2FR;AAxFI;EACI,eAAA;EACA,wCAAA;AA0FR;AAvFI;EACI,+BAAA;EACA,sBAAA;AAyFR;AAvFQ;EEwGJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;AFdJ;AAxFI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA0FR;AAvFI;EC4BA,gBADwB;EAExB,gBAFmC;ADgEvC","sourcesContent":[null,".g-root {\n  --dl-navigation-breadcrumbs-height: 28px;\n  --dl-revision-panel-top-offset: 40px;\n  --dl-color-border: var(--g-color-line-generic);\n  --dl-color-border-solid: var(--g-color-line-generic-solid);\n  --dl-color-progress-bar: var(--g-color-text-info);\n  --dl-color-progress-bar-failed: var(--g-color-base-danger-heavy);\n  --dl-color-field-dimenson: var(--g-color-base-positive-light);\n  --dl-color-field-dimenson-hover: var(--g-color-base-positive-light-hover);\n  --dl-color-field-measure: var(--g-color-base-info-light);\n  --dl-color-field-measure-hover: var(--g-color-base-info-light-hover);\n  --dl-color-field-dimenson-solid: var(--g-color-text-positive);\n  --dl-color-field-measure-solid: var(--g-color-text-info);\n  --dl-color-entity-chart-wizard: #5282ff;\n  --dl-color-entity-chart-ql: #9f6fee;\n  --dl-color-entity-chart-editor: #e18c1e;\n  --dl-color-entity-connection: #9a32a6;\n  --dl-color-entity-dataset: #0abe05;\n  --dl-color-entity-dashboard: #ff8c3c;\n  --dl-color-widget-background: var(--g-color-base-float);\n  --dl-color-text-workbook-icon: var(--g-color-text-dark-primary);\n  --dl-viz-icon-main-color: #3d97f2;\n  --dl-viz-icon-secondary-color: #ff6a59;\n}\n.g-root_theme_light {\n  --g-color-private-cool-grey-20-solid: rgb(245, 246, 247);\n  --ds-color-relation-line: #d9d9d9;\n  --ds-color-avatar: #ededed;\n  --w-local-item-border: rgba(0, 0, 0, 0.5);\n  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);\n  --w-disabled-item-background: rgba(0, 0, 0, 0.07);\n  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);\n  --dl-color-base-workbook-icon: #d1dfff;\n  --dl-filter-ymap-background: none;\n  --dl-filter-ymap-heatmap: none;\n  --dl-color-ymap-background: #fafafa;\n  --dl-filter-zoom-control: none;\n  --dl-color-dashboard-background: var(--g-color-private-cool-grey-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-100-solid);\n}\n.g-root_theme_light-hc {\n  --ds-color-relation-line: #d9d9d9;\n  --ds-color-avatar: #ededed;\n  --w-local-item-border: rgba(0, 0, 0, 0.5);\n  --w-dataset-item-border-hover: rgba(0, 0, 0, 0.15);\n  --w-disabled-item-background: rgba(0, 0, 0, 0.07);\n  --dl-color-contrast-4: rgba(0, 0, 0, 0.04);\n  --dl-color-base-workbook-icon: #a8c3ff;\n  --dl-filter-ymap-background: none;\n  --dl-filter-ymap-heatmap: none;\n  --dl-color-ymap-background: #fafafa;\n  --dl-filter-zoom-control: none;\n  --dl-color-dashboard-background: var(--g-color-private-cool-grey-50-solid);\n  --dl-color-fixed-header-background: var(--g-color-private-cool-grey-150-solid);\n}\n.g-root_theme_dark {\n  --g-color-private-white-20-solid: rgb(49, 48, 55);\n  --ds-color-relation-line: #4c4b51;\n  --ds-color-avatar: #3b3a41;\n  --w-local-item-border: rgba(255, 255, 255, 0.5);\n  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);\n  --w-disabled-item-background: rgba(255, 255, 255, 0.07);\n  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);\n  --dl-color-base-workbook-icon: #c2d0f0;\n  --dl-filter-ymap-background: invert(0.9) saturate(0.4) hue-rotate(-30deg);\n  --dl-filter-ymap-heatmap: invert(0.9) saturate(0.4) hue-rotate(-30deg);\n  --dl-color-ymap-background: transparent;\n  --dl-filter-zoom-control: invert(1);\n  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-base-background);\n}\n.g-root_theme_dark-hc {\n  --g-color-private-white-20-solid: rgb(38, 39, 42);\n  --ds-color-relation-line: #4c4b51;\n  --ds-color-avatar: #3b3a41;\n  --w-local-item-border: rgba(255, 255, 255, 0.5);\n  --w-dataset-item-border-hover: rgba(255, 255, 255, 0.15);\n  --w-disabled-item-background: rgba(255, 255, 255, 0.07);\n  --dl-color-contrast-4: rgba(255, 255, 255, 0.04);\n  --dl-color-base-workbook-icon: #c0d3fd;\n  --dl-filter-ymap-background: invert(0.95) saturate(0.4) hue-rotate(-30deg);\n  --dl-filter-ymap-heatmap: invert(0.95) saturate(0.4) hue-rotate(-30deg);\n  --dl-color-ymap-background: transparent;\n  --dl-filter-zoom-control: invert(1);\n  --dl-color-dashboard-background: var(--g-color-private-white-20-solid);\n  --dl-color-fixed-header-background: var(--g-color-base-background);\n}\n\n@keyframes pulseAnimation {\n  0% {\n    opacity: 0.65;\n  }\n  50% {\n    opacity: 0.35;\n  }\n  100% {\n    opacity: 0.65;\n  }\n}\n.dialog-parameter {\n  width: 560px;\n}\n.dialog-parameter__container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  row-gap: 20px;\n  overflow: visible;\n}\n.dialog-parameter__line {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  column-gap: 16px;\n  min-height: 28px;\n}\n.dialog-parameter__line-title {\n  flex: 0 0 180px;\n  line-height: 18px;\n}\n.dialog-parameter__line-title_vertical-align-start {\n  margin-bottom: auto;\n  transform: translateY(5px);\n}\n.dialog-parameter__line-content {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n.dialog-parameter__switch-template {\n  display: flex;\n  align-items: center;\n  height: 28px;\n  margin-right: auto;\n}\n.dialog-parameter__textarea-regex {\n  margin-top: 8px;\n}\n.dialog-parameter__validation-hint {\n  margin-top: 4px;\n  color: var(--g-color-text-hint);\n}\n.dialog-parameter__template-warning {\n  margin-top: 8px;\n  color: var(--g-color-text-warning-heavy);\n}\n.dialog-parameter__title-tooltip {\n  margin-left: var(--g-spacing-1);\n  vertical-align: middle;\n}\n.dialog-parameter__title-tooltip .yfm {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-1-font-size);\n  line-height: var(--g-text-body-1-line-height);\n}\n.dialog-parameter__loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n.dialog-parameter__dialog-popup {\n  max-height: 40vh;\n  max-width: 400px;\n}",null,null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
